import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { useCompanyStore } from "stores";
// helpers
import { truncate } from "helpers";


const HeadIntranet = (props) => {
  const { name } = useCompanyStore();
  const [metaTitle, setMetaTitle] = useState("");
  const [description, setDescription] = useState("");
  const { t } = useTranslation(['backoffice']);

  useEffect(() => {
    if (!props.home) {
      setMetaTitle(""); // Limpiar temporalmente el título
    }
  }, [props.home]);
  

  useEffect(() => {
    let newMetaTitle;
    if(props.home) {
      newMetaTitle = `${name} | ${t('bookSale')}`;
    } else if (props.title) {
      newMetaTitle = `${t('intranet')} | ${props.title}`;
    } else {
      newMetaTitle = t('intranet');
    }
    setMetaTitle(newMetaTitle);
    setDescription(props.description || "");
  }, [props.home, props.title, props.description, name, metaTitle]);


   useEffect(() => {
    window.document.title = metaTitle;
  }, [metaTitle]);

  return (
    <div className="application">
      <Helmet>
        {props.noIndex && <meta name="robot" content="noindex, nofollow" />}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#000000" />
        <meta name="title" content={metaTitle} />
        <meta
          name="description"
          content={truncate(description ? description : "", 180)}
        />
        <title>{metaTitle}</title>
      </Helmet>
    </div>
  );
};

export default HeadIntranet;
